// src/components/sections/Nosotros/Nosotros.jsx
import React, { useEffect, useState } from 'react';
import SliderHome from '../SliderHome/SliderHome';
import MisionVision from './MisionVision/MisionVision';
import Galeria from './Galeria/Galeria';
import Loader from '../../elements/Loader/Loader';
import useStore from '../../../useStore';
import { useToast } from '../../../Contexts/Toast/toast.provider';

const Nosotros = () => {
  const [banner, setBanner] = useState(null);
  const [galeria, setGaleria] = useState([]);

  // 🔥 Seleccionamos cada parte del store por separado
  const nosotros = useStore(state => state.nosotros);
  const loading = useStore(state => state.loading);
  const error = useStore(state => state.error);
  const fetchNosotros = useStore(state => state.fetchNosotros);

  const showToast = useToast();

  // 1) Al montar, disparamos la carga una sola vez
  useEffect(() => {
    fetchNosotros();
  }, [fetchNosotros]);

  // 2) Si hay error, mostramos toast (una sola vez por cambio de `error`)
  useEffect(() => {
    if (error) {
      showToast('error', `❌ Error al cargar Nosotros: ${error}`);
    }
  }, [error, showToast]);

  // 3) Cuando cambian los datos, derivamos banner y galería
  useEffect(() => {
    if (!Array.isArray(nosotros) || nosotros.length === 0) {
      setBanner(null);
      setGaleria([]);
      return;
    }

    const first = nosotros[0];

    setBanner(
      Array.isArray(first.bannerPrincipalNosotros)
        ? first.bannerPrincipalNosotros[0] || null
        : null
    );
    setGaleria(first.galeriaContent || []);
  }, [nosotros]);

  // 4) Loader o nada
  if (loading) return <Loader />;
  if (!banner && galeria.length === 0) return null;

  return (
    <>
      <SliderHome
        desktopVideoId={banner?.idVideoYTEscritorio}
        mobileVideoId={banner?.idVideoYTMobile}
      />
      <MisionVision />
      <Galeria dataGalery={galeria} />
    </>
  );
};

export default Nosotros;
